import { WRITE_HEADERS } from './podRequests.js'

/**
 * Een akkoord per persoon geven of intrekken langs de pod (`POST /akkoorden?instantie=`, eisenboek 12.56).
 *
 * De pagina schrijft het akkoord niet zelf in het sectiedocument: de pod zet het daar, met persoon en
 * e-mailadres uit het token, het moment van zijn klok en de stand van de inhoud, en het komt hier binnen
 * met de update. Een weigering wordt een fout met de melding van de pod, zodat de control haar toont.
 */
export class ConsentRejected extends Error {
  constructor(message: string, readonly code: string | undefined, readonly status: number) {
    super(message)
    this.name = 'ConsentRejected'
  }
}

export async function postConsent(options: {
  readonly instantieId: string
  readonly headers: Readonly<Record<string, string>>
  readonly request: { readonly sectie: string; readonly veld: string; readonly handeling: 'geven' | 'intrekken' }
  readonly fetch: (input: string, init: RequestInit) => Promise<Response>
  readonly onSessionExpired: () => void
}): Promise<void> {
  const response = await options.fetch(`/akkoorden?instantie=${encodeURIComponent(options.instantieId)}`, {
    method: 'POST',
    headers: { ...options.headers, ...WRITE_HEADERS },
    body: JSON.stringify(options.request),
  })
  if (response.ok) return
  if (response.status === 401) options.onSessionExpired()
  const text = await response.text()
  let code: string | undefined
  let message: string | undefined
  try {
    const parsed = JSON.parse(text) as { code?: unknown; melding?: unknown }
    code = typeof parsed.code === 'string' ? parsed.code : undefined
    message = typeof parsed.melding === 'string' ? parsed.melding : undefined
  } catch {
    code = undefined
  }
  console.error('eformulieren: akkoord niet verwerkt', { status: response.status, code, lijf: text.slice(0, 2000) })
  throw new ConsentRejected(message ?? '', code, response.status)
}
